import { ISchedule } from "@gettactic/api";

export function sortSchedulesByStart(a: ISchedule, b: ISchedule) {
  return a.start.localeCompare(b.start);
}
